import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';

@Injectable()
export class DateInterceptor implements HttpInterceptor {
  iso8601DateTime =
    /^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(\.\d+)?(([+-]\d\d:\d\d)|Z)?$/;
  iso8601Date = /^\d{4}-\d\d-\d\d$/;

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          this.convertDateObjects(event.body);
        }
        return event;
      })
    );
  }

  private convertDateObjects(source: any): any {
    if (source === null || source === undefined) {
      return source;
    }

    if (typeof source !== 'object') {
      return source;
    }

    for (const key of Object.keys(source)) {
      const value = source[key];
      if (this.iso8601Date.test(value)) {
        const date = new Date(`${value}T12:00:00Z`);
        source[key] = date; // TODO: revisar como adicionar offset
      } else if (this.iso8601DateTime.test(value)) {
        source[key] = new Date(value);
      } else if (typeof value === 'object') {
        this.convertDateObjects(value);
      }
    }
  }
}
